import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import {formatCurrency} from 'app/utils/balance/formatCurrency';

interface Props {
    amount: number
}

export default class PokerSidePot extends React.Component<Props> {
    render(): ReactNode {
        return <div className="poker-side-pot">
            <span className="poker-pot-title">{I18n.t('poker.side_pot')}</span>
            <span className="poker-pot-amount">{formatCurrency(this.props.amount)}</span>
        </div>;
    }
}
